import React, { useEffect } from 'react';
import { AccentBlock, Box, Heading, Text, palette, typography } from '@digitools/honest-ui';
import styled from 'styled-components';
import IdentityVerification from '../verification/IdentityVerification';
import useTranslate from 'src/hooks/useTranslate';
import InfoText from './GettingStartedText';
import useAuthentication from 'src/hooks/useAuthentication';
import Notifications, { FunctionalArea } from 'src/components/Notifications/Notifications';
import useTealium from 'src/hooks/useTealium';
import { TEALIUM_EVENT } from 'src/constants/tealiumConstants';
import useAsDataContext from '../../hooks/useAsDataContext';
import { Experience } from 'src/types/Experience';
import useExperience from 'src/hooks/useExperience';
import { CustomEmployeeText } from 'src/utils/CustomExperienceText';
import { AnnouncementOutlined } from '@mui/icons-material';
const InfoSection = styled('section') `
  margin-top: 1.875rem;
`;
// AccentBlock pads the panel, so the last paragraph needs no bottom margin
const InfoPanel = styled(AccentBlock) `
  margin-top: var(--spacing-sm);

  p {
    margin-top: 0;
  }
  p:last-child {
    margin-bottom: 0;
  }
`;
const boxStyle = {
    // TODO(honest-ui gap): no palette token for #C07B03 (alert-warning icon color); confirm with design (gold500 #AC6F20 / gold300 #C9A16E) or add one
    border: `2px solid #C07B03`,
    borderRadius: 'var(--radius-md)',
    display: 'flex',
    width: '75%',
    flexDirection: 'row',
    alignItems: 'center',
};
const infoHeadingStyle = {
    fontSize: typography.fontSize.lg,
    lineHeight: typography.lineHeight.xl,
};
const GettingStarted = () => {
    const { t } = useTranslate();
    const { experience } = useExperience();
    const { user } = useAuthentication();
    const { trackView } = useTealium();
    const { setDocuments, setClaimantData, setAccommodationRequestDataArray, setConditionData, accommodationResponse, setAccommodationResponse, } = useAsDataContext();
    // Dev use only: Use this to jump around the interview steps
    // const stepper = useContext(StepperContext);
    // useEffect(() => {
    //   stepper.goToStep(2);
    // }, []);
    const identityVerificationTitleDetails = experience === Experience.EMPLOYEE
        ? t(InfoText.identityVerificationTitleDetailsEE)
        : t(InfoText.identityVerificationTitleDetailsER);
    const supportingDocumentationDetails = CustomEmployeeText(experience === Experience.EMPLOYEE
        ? t(InfoText.supportingDocumentationDetailsEE)
        : t(InfoText.supportingDocumentationDetailsER));
    const supportingDocumentationMoreDetails = CustomEmployeeText(experience === Experience.EMPLOYEE
        ? t(InfoText.supportingDocumentationMoreDetailsEE)
        : t(InfoText.supportingDocumentationMoreDetailsER));
    useEffect(() => {
        if (accommodationResponse !== undefined) {
            setClaimantData({});
            setAccommodationResponse({});
            setAccommodationRequestDataArray([]);
            setConditionData({});
            setDocuments([]);
        }
        trackView({
            page_l3: TEALIUM_EVENT.EVENT_TYPE.ACCOMMODATION,
        });
    }, []);
    return (<div style={{ marginBottom: 'var(--spacing-md)' }}>
        <Notifications data-testid='start-notification-banner' functionalArea={FunctionalArea.AS}/>
        <Heading as={'h3'} visualLevel='h2' className='hui-mb-xl'>{t(InfoText.pageTitle)}</Heading>
        <Heading className='hui-mb-md' data-private={true} as='h4' visualLevel='h3' weight='bold' color='secondary' data-testid={`asWelcomeMessage`}>
          {t(InfoText.welcomeTxt)} {user?.firstName}{' '}
        </Heading>
        <Box style={boxStyle}>
          <AnnouncementOutlined sx={{ color: palette.garnet500, fontSize: { xs: '2rem', sm: '2.5rem' }, mr: '0.5rem', flexShrink: 0 }}/>
          <Text as='p' size='md' style={{ lineHeight: 'var(--line-height-xs)' }}>
            {t(InfoText.pageInfo)}
          </Text>
        </Box>
        <InfoSection data-public={true}>
          <Heading as='h3' weight='bold' color='secondary' style={infoHeadingStyle}>
            {t(InfoText.header)}
          </Heading>
          <InfoPanel>
            <Heading as='h4' visualLevel='h3' weight='bold' className='hui-mb-xxs' style={infoHeadingStyle}>{t(InfoText.identityVerificationTitle)}</Heading>
            <Text size='md' className='hui-mb-md'>{identityVerificationTitleDetails}</Text>

            <Heading as='h4' visualLevel='h3' weight='bold' className='hui-mb-xxs' style={infoHeadingStyle}>{t(InfoText.accomodationDetailsTitle)}</Heading>
            <Text size='md' className='hui-mb-md'>{t(InfoText.accomodationDetails)}</Text>

            <Heading as='h4' visualLevel='h3' weight='bold' className='hui-mb-xxs' style={infoHeadingStyle}>{t(InfoText.supportingDocumentationTitle)}</Heading>
            <Text size='md' className='hui-mb-lg'>{supportingDocumentationDetails}</Text>

            <Text size='md' className='hui-mb-lg'>{supportingDocumentationMoreDetails}</Text>
            {experience === Experience.EMPLOYEE && (<Text size='md' className='hui-mb-md'>
                <b>{t(InfoText.noteTxt)}</b>
                {t(InfoText.noteDetails)}
              </Text>)}
          </InfoPanel>
        </InfoSection>
        <IdentityVerification />
    </div>);
};
export default GettingStarted;
